/* eslint-disable no-unused-vars */
import clientConfigurationProvider from "../providers/clientConfigurationProvider";

const { dynamicChunkPath } = clientConfigurationProvider();
// eslint-disable-next-line no-undef
__webpack_public_path__ = dynamicChunkPath;
